const Match = require('@/tbs/model/to/Match')

const match = new Match

/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_MatchScheduleManager = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchScheduleManager.prototype = {
    /* The view object name */
    name: '',
    /* The view object instance */
    view: {
        manage: [
            {
                name: 'schedule',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getBMMatchGameRoundList',
                query: {
                    matchId: 'id'
                },
                basePath: 'data',
                rule: {
                    roundCount: '$list',
                    roundTotal: 'list.length',
                    rounds: '$list'
                }
            },
            {
                name: 'role',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetMatchMyManagerRole',
                query: {
                    matchId: 'id'
                },
                basePath: 'data',
                rule: {
                    isManager: '@isManager',
                    isReferee: '@isReferee',
                }
            },
        ]
    },
    renderRoundCount: function(list) {
        let roundCount = 0
        for (let i = 0; i < list.length; i++) {
            let item = list[i]
            if (item.gameCount > 0) {
                roundCount++
            }
        }
        return roundCount
    },
    renderRounds: function(list) {
        let rounds = []
        for (let i = 0; i < list.length; i++) {
            let item = list[i]
            let type
            if (item.isGroupGame == 1 
                && (item.name.indexOf(match.localeProp('round-game')) > -1 || item.name.indexOf(match.localeProp('division')) > -1)) {
                type = match.localeProp('division-game') 
            }
            else if (item.isGroupGame == 0 
                && item.name.indexOf(match.localeProp('round-game')) > -1) {
                type = match.localeProp('league-game')
            }
            else if (item.name.indexOf(match.localeProp('eliminated-game')) > -1) {
                const currentStageRounds = list.filter(round => (round.stageId == item.stageId))
                console.log('currentStageRounds', currentStageRounds)
                const totalRoundNum = currentStageRounds.length
                if (totalRoundNum == item.round) {
                    type = match.localeProp('final-game')
                }
                else if (totalRoundNum - 1== item.round) {
                    type = match.localeProp('semi-final-game')
                }
                else {
                    const diff = totalRoundNum - item.round
                    type = '1/' + Math.pow(2, diff) + match.localeProp('final-game')
                }
            }
            rounds.push({
                index: i + 1,
                stageId: item.stageId,
                seq: match.localeProp('round-seq', {seq: i + 1}),
                type: type,
                gameCount: item.gameCount,
                round: item.round,
                isGroupRound: item.isGroupGame == 1 ? true : false
            })
        }
        console.log('@rounds', rounds)
        return rounds
    },
}

module.exports = tbs_model_vo_MatchScheduleManager